export default __webpack_public_path__ + "static/media/ΦΑΕΕΕ_ΗΛ.c52acde7.png";